import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * GR.6. Asks an open Skills Survey to go to a step.
 *
 * The survey follows `?step=` in its address, but a way in pressed while the
 * address already says that step (the locked Goals Report button pressed a
 * second time on /skills-survey?step=goals) is the same address to the
 * router, which then does nothing. This carries the request instead. The
 * survey honors it by the same rule as landing, so it never skips a step the
 * member still owes. No dependencies, so anything can inject it.
 */
@Injectable({ providedIn: 'root' })
export class SkillsSurveyStepRequests {
  private readonly requests = new Subject<string>();

  public readonly requested$: Observable<string> =
    this.requests.asObservable();

  public request(step: string): void {
    this.requests.next(step);
  }
}
